import { z } from 'zod'
import { TFunction } from 'i18next'
import { NEWS_LIMITS, validNewsBody, validNewsImageMetadata, validNewsUrl } from './news.shared'
export const newsErrorReason = (error: unknown) => (error as { details?: { reason?: string } })?.details?.reason
export const isPostUnavailable = (error: unknown) => newsErrorReason(error) === 'POST_UNAVAILABLE'
export const newsDate = (date: string, withTime = false) =>
  new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Athens',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    ...(withTime ? { hour: '2-digit', minute: '2-digit', hour12: false } : {}),
  }).format(new Date(date))
export const newsPostSchema = (t: TFunction) =>
  z.object({
    body: z.string().refine((value) => validNewsBody(value, NEWS_LIMITS.post), t('news.bodyInvalid')),
    externalUrl: z.string().refine(validNewsUrl, t('news.urlInvalid')),
    image: z
      .instanceof(File)
      .optional()
      .refine((file) => !file || validNewsImageMetadata(file.name, file.type, file.size), t('news.imageInvalid')),
  })
export const newsCommentSchema = (t: TFunction) =>
  z.object({
    body: z.string().refine((value) => validNewsBody(value, NEWS_LIMITS.comment), t('news.commentInvalid')),
  })
